export default class Assignment {
  constructor(
    chore,
    housemate,
    { date, propertyID, internalName, customID, uuid } = {}
  ) {
    this.chore = chore
    this.housemate = housemate
    this.date = date
    this.propertyID = propertyID
    this.internalName = internalName
    this.customID = customID
    this.uuid = uuid
  }
}
